module.exports = __webpack_public_path__ + "img/exchangeboxline.d8758828.svg";